$(document).ready(function () {
    setTimeout(function () {
        var span_Text = $(".rc-widget .rc-selling-plans-single").text();
        var strarray = span_Text.split(",");
        console.log("span_Text" + strarray[1]);
        $(".rc-widget .rc-selling-plans-single").text(strarray[0]);
    }, 1000);
    var showChar = 300;
    var moretext = "Read more >";
    var lesstext = "Read less";
    var i = 0;
    var str = "";
    $(".text-expander").each(function () {
        var content = $(this).html();
        var conct = content.split(" ");
        for (i; i <= 300; i++) {
            str = str + conct[i] + " ";
        }
        var html = '<div class="shorttxt">' + str + '</div><div class="long-txt hidden">' + content + "</div>";
        $(this).html(html);
    });
    $(".text-expander-trigger").click(function () {
        if ($(this).hasClass("read-more")) {
            $(this).removeClass("read-more");
            $(this).addClass("read-less");
            $(this).html(lesstext);
            $(".text-expander").find(".long-txt").removeClass("hidden");
            $(".text-expander").find(".shorttxt").addClass("hidden");
        } else {
            $(this).addClass("read-more");
            $(this).html(moretext);
            $(".text-expander").find(".long-txt").addClass("hidden");
            $(".text-expander").find(".shorttxt").removeClass("hidden");
        }
        return !1;
    });
    if (screen.width < 740) {
        $(document).ready(function () {
            $(".changevid").click(function (e) {
                e.preventDefault();
                event.stopPropagation();
                console.log("i clicked");
                $(this).next(".mobile-overlay-partial").css("display", "block");
                return !1;
            });
            $(".close-info-var").click(function (e) {
                console.log("i closed");
                $(this).parent().parent(".mobile-overlay-partial").css("display", "none");
            });
        });
    }
});
$(document).on("change", ".grinds-parent .block-var__radio", function () {
    $(".grind-element-desktop").removeClass("bgactive");
    $(this).parents(".select-wrapper").find(".selct-vri-btn").addClass("picked");
    if ($(this).is(":checked")) {
        $(this).parent().addClass("bgactive");
    }
});
var iptval = $(".rc-radio-group__options input[type='radio']").val();
$(window).on("load", function () {
    $(".product-form__option-selector").find("combo-box").removeAttr("open");
    setTimeout(function () {
        $(".benefits .rc-radio-group__options label:first-child").after(
            '<ul class="my-list benefitList_cpXEf"><li class="benefitsName_phHoL"><div class="tick_eLdKW"></div><span>15% off every future subscription order.</span></li><li class="benefitsName_phHoL"><div class="tick_eLdKW"></div><span>Free V.I.P shipping, always.</span></li><li class="benefitsName_phHoL"><div class="tick_eLdKW"></div><span>Subscribers help plant trees</span></li><li class="hidden benefitsName_phHoL"><div class="tick_eLdKW"></div><span>Love it or your money back</span></li><li class="hidden benefitsName_phHoL"><div class="tick_eLdKW"></div><span>Commitment free, cancel anytime</span></li><li class="benefitsName_phHoL"><div class="tick_eLdKW"></div><span> Digital coffee course worth £99.</span></li><p id="read-more-benefits">see all benefits (6)</p></ul><div class="var-choice-msg hidden"><p>CANCEL ANYTIME / QUALITY GUARANTEE</p></div>'
        );
    }, 300);
    setTimeout(function () {
        $(".new-design-main-product .rc-radio-group__options label.subscription-radio").after(
            '<ul class="my-list benefitList_cpXEf repositioned"><li class="benefitsName_phHoL"><div class="content-wrapper"><div class="tick_eLdKW"></div><span>You save extra <span class="discount-percentage">' +
                15 +
                '</span>% off</div><div class="per-cup-cost"></div></li><li class="benefitsName_phHoL"><div class="tick_eLdKW"></div><span>Free priority shipping</span></li><li class="benefitsName_phHoL"><div class="tick_eLdKW"></div><span>Cancel or skip easily anytime</span></li><li class="hidden benefitsName_phHoL"><div class="tick_eLdKW"></div><span>Digital coffee course worth £99 </span></li><li class="hidden benefitsName_phHoL"><div class="tick_eLdKW"></div><span>Plant trees with every order</span></li><li class="hidden benefitsName_phHoL"><div class="tick_eLdKW"></div><span> Early access to new products</span></li><p id="read-more-benefits">+More Benefits</p></ul>'
        );
    }, 1000);
    setTimeout(function () {
        $(".template--rotate-espresso-1 .rc-selling-plans").before(
            '<ul class="my-list benefitList_cpXEf repositioned"><h2 class="benefits-heading">Subscription benefits:</h2><li class="benefitsName_phHoL"><div class="tick_eLdKW"></div><span>15% off every future subscription order.</span></li><li class="benefitsName_phHoL"><div class="tick_eLdKW"></div><span>Free priority shipping, always.</span></li><li class="benefitsName_phHoL"><div class="tick_eLdKW"></div><span>Subscribers help plant trees.</span></li><li class="hidden benefitsName_phHoL"><div class="tick_eLdKW"></div><span>VIP deals on new products.</span></li><li class="hidden benefitsName_phHoL"><div class="tick_eLdKW"></div><span>Cancel, skip or swap with 1 click.</span></li><li class="benefitsName_phHoL hidden"><div class="tick_eLdKW"></div><span> Digital coffee course worth £99.</span></li><p id="read-more-benefits">+More Benefits</p></ul></div>'
        );
    }, 1000);
    var dataIds = $(".rc-radio-group__options label:first-child").find(".price-label").text();
    console.log("default price " + dataIds);
    $("#AddToCart #custom-price--large").text(dataIds);
    $(".product-sticky-form").find(".custom-product-sticky-form__price").text(dataIds);
});
$(document).on("click", ".rc-radio-group__options input[type='radio']", function () {
    if ($(this).closest("label").hasClass("rc-radio--active") && $(this).closest("label").hasClass("subscription-radio")) {
        $("#AddToCart #buy-btn-txt").text("Try Now");
        $(".rc-widget").find(".rc-subscription-details").removeClass("hiddens");
        var dataId = $(this).next(".rc-radio__label").find(".price-label").text();
        console.log("dataId" + dataId);
        $(".custom--product-form--1").find(".product-form__add-button .loader-button__text span#custom-price--large").text(dataId);
        $(".custom--product-form--2").find(".product-form__add-button .loader-button__text span#custom-price--large").text(dataId);
        $(".custom--product-form--2")
            .find(".product-form__add-button .loader-button__text1212")
            .text("Add to cart - " + dataId);
        $(".product-sticky-form").find(".product-sticky-form__price").text(dataId);
    } else {
        console.log("input2st");
        $(".benefitList_cpXEf").hide();
        $(".var-choice-msg").removeClass("hidden");
        $("#AddToCart #buy-btn-txt").text("Add to Cart");
        var dataId = $(this).next(".rc-radio__label").find(".price-label").text();
        console.log("dataId" + dataId);
        $(".custom--product-form--1").find(".product-form__add-button .loader-button__text span#custom-price--large").text(dataId);
        $(".custom--product-form--2").find(".product-form__add-button .loader-button__text span#custom-price--large").text(dataId);
        $(".custom--product-form--2")
            .find(".product-form__add-button .loader-button__text1212")
            .text("Add to cart - " + dataId);
        $("#custom--product-form--darkfireenergy")
            .find(".product-form__add-button .loader-button__text1212")
            .text("Pre-Order -" + dataId);
        $(".product-sticky-form").find(".product-sticky-form__price").text(dataId);
        console.log("hi2");
        $(".rc-widget").find(".rc-subscription-details").addClass("hiddens");
    }
});
$(document).ready(function () {
    $(document).on("click", "#read-more-benefits", function (event) {
        console.log("benefits");
        $(this).parent(".my-list").find("li").removeClass("hidden");
        $(this).hide();
    });
});
$(document).on("click", ".desktop-overlay-var", function (event) {
    var $trigger = $(".grinds-parent");
    $(this).parents("combo-box").removeAttr("open");
});
$(document).on("click", ".subscription_change", function (event) {
    console.log("subscription_change");
    var dataId = $(".custom--product-form--2").find(".rc-radio--active .price-label").text();
    console.log("The data-id of clicked item is: " + dataId);
    $("#AddToCart #custom-price--large").text(dataId);
    $(".product-sticky-form").find(".custom-product-sticky-form__price").text(dataId);
});
$(document).on("click", ".block-swatch__item", function (event) {

    if (window.location.href.indexOf("monthly-gift-subscription") !== -1) {
        console.log("Skipping swatch click handler for gift subscription");
        return; // Exit the function early
    }
  
    var optionval = $(this).data("rel");
    console.log("optionval" + optionval);
    console.log("trigger");
    setTimeout(function () {
        $(".benefits .rc-radio-group__options .rc-radio--active input[type='radio']").trigger("click");
        console.log("trigger");
    }, 2000);
    setTimeout(function () {
        $(".template--rotate-espresso-1 .rc-radio-group__options .rc-radio--active input[type='radio']").trigger("click");
        console.log("trigger");
    }, 10);
    $(this).parents(".product-form").find(".product-form__add-button .loader-button__text").css("display", "none");
    if ($(this).parents(".product-form").find(".product-form__add-button .loader-button__text1212").length > 0) {
        $(this)
            .parents(".product-form")
            .find(".product-form__add-button .loader-button__text1212")
            .text("Add to cart - " + optionval);
        setTimeout(function () {
            $(".product-sticky-form").find(".product-sticky-form__price").text(optionval);
        }, 100);
    } else {
        $(this)
            .parents(".product-form")
            .find(".product-form__add-button")
            .append('<span class="loader-button__text1212">Add to cart - ' + optionval + "</span>");
        setTimeout(function () {
            $(".product-sticky-form").find(".product-sticky-form__price").text(optionval);
        }, 100);
    }
});
$(document).on("click", ".subscriptionProd .combo-box__option-item", function (event) {
    var varid = $(this).parents(".product-form").find('input[name="id"]').val();
    var productHandle = $(this).parents(".product-form").attr("data-producthandle");
    console.log(" varid :: " + varid);
    var varprice = "";
    var data = {};
    jQuery.ajax({
        type: "GET",
        url: productHandle,
        dataType: "json",
        success: function (data) {
            console.log("Product Object 1: ", data);
            $.each(data.product.variants, function (k, v) {
                console.log(k + " .. " + v.id);
                if (v.id == varid) {
                    console.log(k + " ... " + v.price);
                    varprice = v.price;
                    console.log(varprice + " :: varprice");
                    $(".product-form").find(".product-form__add-button .loader-button__text").css("display", "none");
                    if ($(".product-form").find(".product-form__add-button .loader-button__text1212").length > 0) {
                        $(".product-form")
                            .find(".product-form__add-button .loader-button__text1212")
                            .text("Add to cart - £" + varprice);
                    } else {
                        $(".product-form")
                            .find(".product-form__add-button")
                            .append('<span class="loader-button__text1212">Add to cart - £' + varprice + "</span>");
                    }
                    $(".product-sticky-form")
                        .find(".product-sticky-form__price")
                        .text("£" + varprice);
                }
            });
        },
        error: function (xhr, status, error) {
            console.log(xhr.responseText);
        },
    });
});
$(document).on("click", ".custom--product-form--1 .combo-box__option-item, .product-form .combo-box__option-item", function (event) {
    console.log("hiii...");
    var optionval = $(this).data("rel");
    console.log("optionval" + optionval);
    var optionavail = $(this).data("avail");
    var selectedVal = $(this).attr("value");
    $(this).parents(".product-form__option-selector").find(".selct-vri-btn .select__selected-value").text(selectedVal);
    var varid = $(this).parents(".product-form").find('input[name="id"]').val();
    var productHandle = $(this).parents(".product-form").attr("data-producthandle");
    var finalpricetoattche = $(".recharge-subscription-widget").find(".rc-radio--active .price-label").text();
    console.log("finalpricetoattche" + finalpricetoattche);
    if (finalpricetoattche == "") {
        var varid = $(this).parents(".product-form").find('input[name="id"]').val();
        var productHandle = $(this).parents(".product-form").attr("data-producthandle");
        console.log(" varid :: " + varid);
        var varprice = "";
        var data = {};
        jQuery.ajax({
            type: "GET",
            url: productHandle,
            dataType: "json",
            success: function (data) {
                console.log("Product Object 1: ", data);
                $.each(data.product.variants, function (k, v) {
                    if (v.id == varid) {
                        varprice = v.price;
                        console.log(varprice + " :: varprice");
                        $(".product-form").find(".product-form__add-button .loader-button__text").css("display", "none");
                        if ($(".product-form").find(".product-form__add-button .loader-button__text1212").length > 0) {
                            $(".product-form")
                                .find(".product-form__add-button .loader-button__text1212")
                                .text("Add to cart - £" + varprice);
                        } else {
                            $(".product-form")
                                .find(".product-form__add-button")
                                .append('<span class="loader-button__text1212">Add to cart - £' + varprice + "</span>");
                        }
                        $(".product-sticky-form")
                            .find(".product-sticky-form__price")
                            .text("£" + varprice);
                    }
                });
            },
        });
    } else {
        $(".product-form").find(".product-form__add-button .loader-button__text").css("display", "none");
        if ($(".product-form").find(".product-form__add-button .loader-button__text1212").length > 0) {
            $(".product-form")
                .find(".product-form__add-button .loader-button__text1212")
                .text("Add to cart - " + finalpricetoattche);
        } else {
            $(".product-form")
                .find(".product-form__add-button")
                .append('<span class="loader-button__text1212">Add to cart - ' + finalpricetoattche + "</span>");
        }
        $(".product-sticky-form").find(".product-sticky-form__price").text(finalpricetoattche);
    }
});
$(document).ready(function () {
    $(".template--product .product-form .combo-box__option-list .combo-box__option-item").on("click", function () {
        $(".template--product .product-form .combo-box__option-list .combo-box__option-item").attr("aria-selected", "false");
        $(this).attr("aria-selected", "true");
        if ($('.combo-box__option-list .combo-box__option-item[aria-selected="true"]').length > 0) {
            $(".template--product .product-form .select-wrapper .not_beans_ground.selct-vri-btn").addClass("sele_beans_ground");
        } else {
            $(".template--product .product-form .select-wrapper .not_beans_ground.selct-vri-btn").removeClass("sele_beans_ground");
        }
    });
});
document.querySelectorAll(".template--stability-blend-one-time .product__info .faq__item").forEach((item) => {
    item.addEventListener("click", function () {
        const collapsible = this.querySelector(".template--stability-blend-one-time .product__info .faq__item .collapsible");
        if (collapsible.hasAttribute("open")) {
            collapsible.removeAttribute("open");
        } else {
            collapsible.setAttribute("open", "open");
        }
    });
});

// jfi labels elixirs js, js script to add a <br> before  "for" on desktop
document.addEventListener("DOMContentLoaded", function () {
    const tastingNotesElements = document.querySelectorAll(".tasting-notes-jfi-labels");
    const isDesktop = window.matchMedia("(min-width: 768px)").matches;

    tastingNotesElements.forEach((element) => {
        let text = element.innerHTML;

        if (text.includes("For")) {
            // Add a line break for desktop; remove "For" for other devices
            text = isDesktop ? text.replace(/\bFor\b/, "<br>For") : text.replace(/\bFor\b/, "");
            element.innerHTML = text;
        }
    });
});


// Script to hide ATC btn for gifts and such

(function() {
    const giftHandles = [
      'products/mystery-gift',
      'products/cordyceps-elixir-10ml-gift',
      'products/lions-mane-elixir-10ml-gift'
    ];
  
    const currentPath = window.location.pathname;
    const shouldHideButton = giftHandles.some(handle => currentPath.includes(handle));
  
    if (shouldHideButton) {
      const atcButton = document.getElementById('AddToCart');
      if (atcButton) {
        atcButton.style.display = 'none';
      }
    }
  })();

//  Function to add a dynamic date to each landing page
// document.addEventListener("DOMContentLoaded", function () {
//   // add all of the landing page handles here
//   if (window.location.pathname === "/pages/lp-cs") {
//     var dateElement = document.getElementById("lp-date");
//     if (dateElement) {
//       var today = new Date();
//       var options = { year: 'numeric', month: 'long', day: 'numeric' };
//       var formattedDate = today.toLocaleDateString('en-US', options);
//       dateElement.innerHTML = "<i>Last Updated " + formattedDate + "</i>";
//     }
//   }
// });

// FUNCTION to remove all gifts from the cart if the bundle is removed in any way

document.addEventListener('DOMContentLoaded', () => {

  /* ---------- settings ---------- */
  const BUNDLE_HANDLE   = 'coffee-starter-bundle-offer';
  const BUNDLE_CLASS    = 'product-coffee-starter-bundle-offer'; 
  const GIFT_FLAG       = '_free_gift';
  const REBUY_EVENTS    = ['rebuy.cart.change', 'rebuy.cart.refresh'];
  const DELAY_MS        = 600;

  async function enforceGiftRules() {
    try {
      const cart = await fetch('/cart.js').then(r => r.json());

      const bundleStillInCart = cart.items.some(item =>
        item.handle === BUNDLE_HANDLE ||
        item.key?.includes(BUNDLE_HANDLE) ||
        item.properties?._bundle_handle === BUNDLE_HANDLE
      );

      if (bundleStillInCart) return; 
      const gifts = cart.items.filter(i => i.properties?.[GIFT_FLAG] === 'true');
      if (!gifts.length) return;

      const updates = {};
      gifts.forEach(g => { updates[g.id] = 0; });

      await fetch('/cart/update.js', {
        method : 'POST',
        headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
        body   : JSON.stringify({ updates })
      });

      console.log('[Gift-Guard] Removed gifts because bundle is missing.');

      if (window.Rebuy?.SmartCart?.render) {
        window.Rebuy.SmartCart.render();
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }

    } catch (err) {
      console.error('[Gift-Guard] Error:', err);
    }
  }

  /* ---------- listeners ---------- */
  REBUY_EVENTS.forEach(evt =>
    document.addEventListener(evt, () => setTimeout(enforceGiftRules, DELAY_MS))
  );

  document.body.addEventListener('click', e => {
    const removeBtn = e.target.closest('.rebuy-cart__flyout-item-remove');
    if (removeBtn &&
        removeBtn.closest(`.${BUNDLE_CLASS}`)) {
      setTimeout(enforceGiftRules, DELAY_MS);
    }
  });

  document.body.addEventListener('click', e => {
    if (e.target.closest('.rebuy-cart__flyout-item-quantity-widget')) {
      setTimeout(enforceGiftRules, DELAY_MS);
    }
  });

});

// Blog back to the top button JSa
document.addEventListener("DOMContentLoaded", function () {
  const backToTopBtn = document.querySelector(".bc-back-to-top-btn");

  // return if backToTopBtn not found
  if (!backToTopBtn) return;

  // Show button after scrolling 300px
  window.addEventListener("scroll", function () {
    if (window.scrollY > 300) {
      backToTopBtn.classList.add("visible");
    } else {
      backToTopBtn.classList.remove("visible");
    }
  });

  // Scroll to top on click
  backToTopBtn.addEventListener("click", function () {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });
});


const interval = setInterval(() => {
  const prompt = document.querySelector('.rebuy-cart__progress-gift-variant-select-prompt');
  if (prompt) {
    prompt.textContent = "Select Grind";
    clearInterval(interval);
  }
}, 200);

